import React from "react";
import {
  Card,
  Typography,
  Row,
  Col,
  Timeline,
  Statistic,
  Tag,
  Divider,
} from "antd";
import {
  RocketOutlined,
  TeamOutlined,
  TrophyOutlined,
  HeartOutlined,
  BulbOutlined,
  GlobalOutlined,
  StarOutlined,
  CheckCircleOutlined,
  UserOutlined,
  CalendarOutlined,
  EnvironmentOutlined,
  PhoneOutlined,
} from "@ant-design/icons";
import Footer from "./Components/Footer";

const { Title, Paragraph, Text } = Typography;

function Aboutus() {
  const stats = [
    { title: "Years of Experience", value: 10, suffix: "+" },
    { title: "Happy Clients", value: 500, suffix: "+" },
    { title: "Projects Completed", value: 1200, suffix: "+" },
    { title: "Team Members", value: 25, suffix: "+" },
  ];

  const values = [
    {
      icon: <BulbOutlined className="text-blue-500" />,
      title: "Innovation",
      description:
        "We constantly push the boundaries of technology to deliver cutting-edge solutions that drive your business forward.",
    },
    {
      icon: <HeartOutlined className="text-red-500" />,
      title: "Passion",
      description:
        "Our team is passionate about what we do, bringing enthusiasm and dedication to every project we undertake.",
    },
    {
      icon: <CheckCircleOutlined className="text-green-500" />,
      title: "Quality",
      description:
        "We maintain the highest standards in everything we deliver, ensuring excellence in every aspect of our work.",
    },
    {
      icon: <GlobalOutlined className="text-purple-500" />,
      title: "Global Reach",
      description:
        "With clients across the globe, we bring international expertise and local understanding to every project.",
    },
  ];

  const timeline = [
    {
      color: "blue",
      children: (
        <div>
          <Title level={5} className="mb-2">
            Company Founded
          </Title>
          <Text className="text-gray-600">
            Started our journey with a vision to transform businesses through
            technology
          </Text>
        </div>
      ),
    },
    {
      color: "green",
      children: (
        <div>
          <Title level={5} className="mb-2">
            First Major Client
          </Title>
          <Text className="text-gray-600">
            Successfully delivered our first enterprise-level solution
          </Text>
        </div>
      ),
    },
    {
      color: "orange",
      children: (
        <div>
          <Title level={5} className="mb-2">
            Team Expansion
          </Title>
          <Text className="text-gray-600">
            Grew our team to include specialists in various technology domains
          </Text>
        </div>
      ),
    },
    {
      color: "purple",
      children: (
        <div>
          <Title level={5} className="mb-2">
            Global Recognition
          </Title>
          <Text className="text-gray-600">
            Received industry awards for innovation and client satisfaction
          </Text>
        </div>
      ),
    },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-blue-50">
      <div className="max-w-6xl mx-auto px-4 py-16">
        <div className="mb-16">
          <Title level={2} className="text-center mb-8 text-gray-800">
            About Us
          </Title>
          <Card className="shadow-lg">
            <Paragraph className="text-gray-600 text-lg text-center mb-6">
              Welcome to Skyra Converter, a fast, secure, and free online image
              converter designed to simplify your file conversion needs. We
              support a wide variety of image formats, helping users convert
              files easily without the need for downloads or signups. Whether
              you're working on a desktop, tablet, or smartphone, our web-based
              tool ensures smooth and responsive performance on any device
            </Paragraph>
            <Paragraph className="text-gray-600 text-lg text-center mb-6">
              At Skyra Converter, we focus on delivering a hassle-free image
              conversion experience with quick uploads, seamless processing, and
              reliable results. Whether you're a designer, student, or everyday
              user, our goal is to make image and file format conversion
              effortless so you can save time and stay productive.
            </Paragraph>

            <Paragraph className="text-gray-600 text-lg text-center mb-6" >
              We value your privacy and security. Every image you upload is
              automatically deleted from our servers after 30 minutes. This
              ensures your data stays safe while you enjoy a fast, smooth, and
              hassle-free conversion. No storage, no tracking — just quick and
              secure results. Trust us to keep your files private, every time
              you convert.
            </Paragraph>
          </Card>
        </div>

        {/* Why Choose Us */}

        {/* Contact Information */}
        {/* <Card className="shadow-lg text-center">
          <Title level={2} className="mb-6 text-gray-800">
             Contact Us
          </Title>

          <Row gutter={[32, 16]} justify="center">
            <Col xs={24} md={8}>
              <div className="flex items-start justify-center space-x-2 ">
                <EnvironmentOutlined className="text-blue-500 mt-1" />
                <Text className="text-gray-600 text-left">
                  Skyraan Technologies, No.17, Sri Venkateshwara Towers, FCI Rd,
                  opp. Fire Station, Gandhimaa Nagar, Peelamedu, Coimbatore,
                  Tamil Nadu 641004
                </Text>
              </div>
            </Col>
            <Col xs={24} md={8}>
              <div className="flex items-center justify-center space-x-2">
                <PhoneOutlined className="text-blue-500" />
                <Text className="text-gray-600">+91 97918 82387</Text>
              </div>
            </Col>
            <Col xs={24} md={8}>
              <div className="flex items-center justify-center space-x-2">
                <GlobalOutlined className="text-blue-500" />
                <Text className="text-gray-600 ">www.skyraan.com</Text>
              </div>
            </Col>
          </Row>
        </Card> */}
      </div>
      <Footer />
    </div>
  );
}

export default Aboutus;
